import { TallyMark1Icon } from './TallyMark1Icon';

/**
 * author: Michael Irigoyen
 * id 1F0D9425-0B92-46C6-AEBE-39FB5E062AA5
 * name tally-mark-1
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tally-mark-1.svg
 * tags
 * - Math 
 */
export const OneIcon = TallyMark1Icon;
export default OneIcon